import { MenuItem } from '@headlessui/react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router';

const BASE_CLASSES =
  'data-active-text-rcprimary-400 group flex w-full items-center justify-start gap-x-2.5 px-4 py-2 text-left text-sm disabled:cursor-not-allowed disabled:opacity-50 data-focus:bg-white/5';

const ICON_CLASSES =
  'group-hover:text-rcprimary-400 h-5 w-5 mr-2 text-white/60';

function SelectMenuItem({
  to = null,
  onClick = null,
  children,
  icon: Icon = null,
  disabled = false,
  className = '',
}) {
  const buttonClasses =
    className.trim().length > 0
      ? `${BASE_CLASSES} ${className}`
      : `${BASE_CLASSES} text-gray-300 hover:text-white`;

  return (
    <MenuItem>
      {to ? (
        <NavLink to={to} disabled={disabled} className={buttonClasses}>
          {Icon && <Icon className={ICON_CLASSES} />}
          {children}
        </NavLink>
      ) : (
        <button
          type="button"
          onClick={onClick}
          disabled={disabled}
          className={buttonClasses}
        >
          {Icon && <Icon className={ICON_CLASSES} />}
          {children}
        </button>
      )}
    </MenuItem>
  );
}

SelectMenuItem.propTypes = {
  to: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  icon: PropTypes.object,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default SelectMenuItem;
